import { useState, type FormEvent } from "react";
import { useNavigate, Link } from "react-router";
import { Button } from "../components/ui/Button";
import { signUpWithEmail } from "../lib/auth-client";
import { useT } from "../lib/use-t";

export function SignupPage() {
  const t = useT();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(ev: FormEvent) {
    ev.preventDefault();
    if (password.length < 6) {
      setError(t("signup.passwordTooShort"));
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      await signUpWithEmail(email, password);
      nav("/", { replace: true });
    } catch (err) {
      const code = (err as { code?: string }).code;
      if (code === "auth/email-already-in-use") {
        setError(t("signup.emailInUse"));
      } else {
        setError(err instanceof Error ? err.message : t("chrome.common.unknownError"));
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-bg px-5 py-10">
      <div className="w-full max-w-sm space-y-6">
        <h1 className="text-2xl font-semibold tracking-tight text-center">{t("signup.title")}</h1>
        <form onSubmit={onSubmit} className="space-y-3">
          <input type="email" required placeholder={t("signup.emailPlaceholder")} value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-md border border-[var(--border)] bg-[var(--panel-soft)] px-3 py-2 text-sm text-[var(--ink)]" />
          <input type="password" required placeholder={t("signup.passwordPlaceholder")} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full rounded-md border border-[var(--border)] bg-[var(--panel-soft)] px-3 py-2 text-sm text-[var(--ink)]" />
          <Button type="submit" variant="primary" size="lg" disabled={submitting} className="w-full">
            {submitting ? t("signup.submitBusy") : t("signup.submit")}
          </Button>
        </form>
        {error ? <p role="alert" className="rounded-md border border-[var(--fail)] bg-[var(--fail)]/10 px-3 py-2 text-sm text-[var(--fail)]">{error}</p> : null}
        <p className="text-sm text-[var(--ink-muted)] text-center">
          {t("signup.hasAccount")} <Link to="/login" className="text-[var(--accent)]">{t("signup.signIn")}</Link>
        </p>
      </div>
    </main>
  );
}
